import { companyPartialUpdaterBuilder } from "../companyPartialUpdaterBuilder";
import {
  CompanyNameFormik,
  COMPANY_NAME_MESSENGER_CONTEXT,
  validationCompanyNameSectionSchema,
} from "./CompanyNameForm";

export const CompanyNameEdit = companyPartialUpdaterBuilder(CompanyNameFormik, {
  validationSchema: validationCompanyNameSectionSchema,
  messengerContext: COMPANY_NAME_MESSENGER_CONTEXT,
});
